/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_Salvaged_ToastInputs */



/**
* | output |
* | --- |
* | "The file is damaged: captions may be incomplete." |
*
* @param {Subtitle_Extract_Salvaged_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_salvaged_toast = /** @type {((inputs?: Subtitle_Extract_Salvaged_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Salvaged_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le fichier est endommagé : les légendes peuvent être incomplètes.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Datei ist beschädigt: Die Bildunterschriften sind möglicherweise unvollständig.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il file è danneggiato: le didascalie potrebbero essere incomplete.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Файл поврежден: субтитры могут быть неполными.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El archivo está dañado: los subtítulos pueden estar incompletos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件已损坏：字幕可能不完整。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルが破損しています。字幕が不完全な場合があります。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फाइल क्षतिग्रस्त है: कैप्शन अपूर्ण हो सकते हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O arquivo está corrompido: as legendas podem estar incompletas.")
	return /** @type {LocalizedString} */ ("The file is damaged: captions may be incomplete.")
});